/**
 * mira-bangumi-provider API
 * Management API for mira-bangumi-provider
 *
 * The version of the OpenAPI document: 1.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type WebhookHealth = 'Healthy' | 'Unhealthy' | 'Unreachable';

export const WebhookHealth = {
    Healthy: 'Healthy' as WebhookHealth,
    Unhealthy: 'Unhealthy' as WebhookHealth,
    Unreachable: 'Unreachable' as WebhookHealth
};

